export type CommissionCheckoutBlocker = {
  code: string;
  messageKey: string;
};

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Returns checkout blockers for a commission contract.
 * Additive: add new rules here without changing the payment display component.
 */
export function getCommissionCheckoutBlockers(contract: {
  brideEmail?: string | null;
}): CommissionCheckoutBlocker[] {
  const blockers: CommissionCheckoutBlocker[] = [];

  const email = contract.brideEmail?.trim() ?? '';
  if (!email || !EMAIL_REGEX.test(email)) {
    blockers.push({
      code: 'MISSING_OR_INVALID_EMAIL',
      messageKey: 'commission_payment_plan.blockers.missing_email',
    });
  }

  return blockers;
}
